module.exports = __webpack_public_path__ + "img/catalogue-icon.0fcf0d30.svg";